const Footer = () => {

    return (
        <footer>
            <p>&#169; <a href="https://github.com/diegoram23">2023 github.com/diegoram23</a></p>
        </footer>

    )
}

export default Footer;